import {LiveGameFilterDefinitionBase} from "./live-game-filter-definition-base";

export class LiveGameShowsFilterDefinition extends LiveGameFilterDefinitionBase {
    get id(): string {
        return "live-game-shows";
    }

    get text(): string {
        return this.services.translation.translate('LIVE_GAME_SHOWS');
    }

    protected get textToSearchInSubgroupName(): string {
        return "shows";
    }
}